/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ b: NonNullable<unknown> }} Flow_VolumeInputs */



/**
* | output |
* | --- |
* | "Flow rate: {b} m³/h" |
*
* @param {Flow_VolumeInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const flow_volume = /** @type {((inputs: Flow_VolumeInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Flow_VolumeInputs, { locale?: "fr" | "en" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return /** @type {LocalizedString} */ (`Flow rate: ${i?.b} m³/h`)
	return /** @type {LocalizedString} */ (`Débit : ${i?.b} m³/h`)
});